export default "__VITE_PUBLIC_ASSET__9ef31ec1__"